/**
 * Pure decision logic for the Street View auto-trigger (kept dependency-free
 * so it unit-tests without the map/store module graph).
 */

/** What the auto-trigger should do for one poll tick. */
export type AutoAction = 'check-open' | 'close' | 'none';

/**
 * Decide one poll tick. Opens only on the high→low edge when nothing is open
 * and the flag allows it; closes only panoramas the trigger itself opened. A
 * disabled flag still lets an already-open auto panorama close on climb-out.
 */
export function decideAutoAction(input: {
  low: boolean;
  wasLow: boolean;
  open: boolean;
  autoOpened: boolean;
  autoEnabled: boolean;
}): AutoAction {
  if (input.low && !input.wasLow && !input.open && input.autoEnabled) return 'check-open';
  if (!input.low && input.open && input.autoOpened) return 'close';
  return 'none';
}
